<form>
  <!-- Modal Header -->
  <div class="modal-header">
    <h4 class="modal-title">
      <strong>Task Collection List ({{ showDate }})</strong>
    </h4>
    <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()"></button>
  </div>

  <div class="modal-body">
    @if (taskCollectionList.length == 0) {
      <div>
        <p>You do not have any task on this date</p>
      </div>
    } @else {
      @for (taskCollection of taskCollectionList; track taskCollection) {
        <div class="m-3">
          <div class="card task-card">
            <div class="card-body">
              <h4 style="color: blueviolet">
                <strong>Customer: {{ taskCollection.Name }}</strong>
              </h4>
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">Receipt Number</th>
                    <th scope="col">Monthly</th>
                    <th scope="col">Balance</th>
                  </tr>
                </thead>
                <tbody>
                  @for (collection of taskCollection.LoanCollection; track collection) {
                    <tr>
                      <!-- <th scope="row">1</th> -->
                      <td>{{ collection.ReceiptNumber }}</td>
                      <td>{{ collection.MonthlyPayment }}</td>
                      <td>{{ collection.Balance }}</td>
                    </tr>
                  }
                </tbody>
                <tfoot>
                  <tr>
                    <td><b>Total:</b></td>
                    <td>
                      <b>{{ getTotalMonthlyPayment(taskCollection) }}</b>
                    </td>
                    <td>
                      <b>{{ getTotalBalance(taskCollection) }}</b>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      }
    }
  </div>
</form>
